import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { InteractionStatus } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import useInactivityTracker from "../hooks/useInactivityTracker";
import { logOut } from "./auth";

export default function AuthenticationHandler() {
  const { instance, inProgress } = useMsal();
  const [authChecked, setAuthChecked] = useState(false);

  const { tokenExpiration, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  const handleLogout = async () => {
    // The tracker also runs on the signed-out sign-in page, which has nothing to sign out of.
    if (!isAuthenticated || inProgress !== InteractionStatus.None) {
      return;
    }

    try {
      await logOut(instance);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  useInactivityTracker(handleLogout, 600000); // 10 minutes

  // Handle token expiration
  useEffect(() => {
    if (!authChecked && inProgress === InteractionStatus.None) {
      if (tokenExpiration && tokenExpiration < Date.now()) {
        console.log("Token expired, redirecting to login");
      }
      setAuthChecked(true);
    }
  }, [tokenExpiration]);

  return null;
}
